import { render } from "./Posts.vue?vue&type=template&id=c9e0a252"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/derolfgroep-ict/derolfgroep-ict/web/app/themes/rolfhardware/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__